import {observable, computed, action, autorun, reaction, runInAction, toJS} from 'mobx';

export class VReview{
  constructor(flasher, scene, servicesForm, accessoriesForm, rentalTransaction, 
    rentalObject, bestOffers, vServices, vAccessories, businessUnit, searchForm, vBookingWizard, vPayment) {
    this.flasher = flasher;
    this.scene = scene;
    this.servicesForm = servicesForm;
    this.accessoriesForm = accessoriesForm;
    this.rentalTransaction = rentalTransaction;
    this.bestOffers = bestOffers;
    this.rentalObject = rentalObject;
    this.vServices = vServices;
    this.vAccessories = vAccessories;
    this.businessUnit = businessUnit;
    this.searchForm = searchForm;
    this.vBookingWizard = vBookingWizard;
    this.vPayment = vPayment;
  }

  @observable editingId;
  @observable willBook = true;
  @observable agbAccepted = false;
  @observable orgId;
  @observable bookingNote = '';
  @observable bookingNote2 = '';
  @observable voucherCode = '';

  @action.bound setWillBook(state) { 
    this.willBook = state;
  }

  @action.bound setBookingNote(note) {
    this.bookingNote = note;
  }

  @action.bound setBookingNote2(note2) {
    this.bookingNote2 = note2;
  }  

  @action.bound setVoucherCode(code) {
    this.voucherCode = code;
  }    

  @action.bound setAgbAccepted(state) {
    this.agbAccepted = state;
  }

  @action.bound editItemStart(id) {
    this.editingId = id;
  }

  @action.bound editItemStop() {
    this.editingId = null;
  }

  @action.bound saveServiceItem(id) {
    this.editItemStop();
    this.vServices.updateRun();
  }

  @action.bound deleteServiceItem(id) {
    this.servicesForm.dirtyValues.set(id, 0);
    this.vServices.updateRun();
  }

  @action.bound saveAccessoryItem(id) {
    this.editItemStop();
    this.vAccessories.updateRun();
  }

  @action.bound deleteAccessoryItem(id) {
    this.accessoriesForm.dirtyValues.set(id, 0);
    this.vAccessories.updateRun();
  }  

  @action.bound checkVoucherCode = async () => {
    try {
      await this.rentalTransaction.checkVoucherCode({ trxId: this.rentalTransaction.id, code: this.voucherCode });
    }
    catch (e) {
      this.flasher.handleError(e);
    }
  }

  @action.bound reset = () => {
    this.willBook = true;
    this.agbAccepted = false;
    this.bookingNote = '';
    this.bookingNote2 = '';
    this.voucherCode = '';
  }

  async startOrUpdate(state, router) {
    this.orgId = state.orgId;
    this.vBookingWizard.setVisitedStep(5);
    try {
      this.flasher.setOther('Loading.')

      await Promise.all([
        this.vServices.startOrUpdate(state, router, true),
        this.vAccessories.startOrUpdate(state, router, true),
        this.rentalObject.cFetch(state),
        this.rentalTransaction.cFetch(state),
      ])
      await this.businessUnit.cFetch({businessUnitId: this.rentalObject.businessUnitId});
      await this.bestOffers.cFetch({
        startDate: this.rentalTransaction.realRentingStartDate, //window.sessionStorage.getItem('bwStartDate'), //this.startDate,  
        endDate: this.rentalTransaction.realRentingEndDate, //window.sessionStorage.getItem('bwEndDate'), //this.endDate, 
        organizationId: state.orgId,
        objectId: state.objId, 
        timeUnit: this.searchForm.timeUnit, 
        oldStartDate: undefined, 
        oldEndDate: undefined,
      }) 
      this.vServices.resetForm();
      this.vAccessories.resetForm();
    }
    finally {
      this.flasher.setOther();   
    }
  }

  stop() {
    this.vServices.stop();
    this.vAccessories.stop();
  }
} 


// WEBPACK FOOTER //
// ./src/view/VReview.js